import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { ReportingService } from '../../../../services/reporting.service';

import jspdf, { TextOptionsLight } from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable, { Styles } from 'jspdf-autotable';
import { Subject } from 'rxjs';
import { NetworkService } from '../../../../services/network.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../../../environments/environment';
import { _ENDPOINT } from '../../../../endpoints/endpoint';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-completed-detail',
  templateUrl: './completed-detail.component.html',
  styleUrls: ['./completed-detail.component.css']
})
export class CompletedDetailComponent implements OnInit, AfterViewInit {

  @Input() dropdownListBO: any[] = [];
  @Input() selectedItemsBO: any[] = [];
  @Input() dropdownListOrderCluster: any[] = [];
  @Input() selectedItemsOrderCluster: any[] = [];
  @Input() dropdownListCustomer: any[] = [];
  @Input() selectedItemsCustomer: any[] = [];
  @Input() dropdownListCountry: any[] = [];
  @Input() selectedItemsCountry: any[] = [];
  @Input() dropdownListMonth: any[] = [];
  @Input() selectedItemsMonth: any[] = [];
  @Input() dropdownListYear: any[] = [];
  @Input() selectedItemsYear: any[] = [];
  @Input() dropdownListOrderType: any[] = [];
  @Input() selectedItemsOrderType: any[] = [];
  @Input() customerOfCountry: Map<string, string[]>;
  @Input() orderTypeOfOrderCLuster: Map<string, string[]>;
  @Input() idLeadGlobalOfCustomerName: Map<string, string[]>;
  @Input() selectedItemsIdGlobal: any[] = [];
  @Input() dropdownListOrderStatus: any[] = [];
  @Input() selectedItemsOrderStatus: any[] = [];
  @Input() dropdownListLead: any[] = [];
  @Input() selectedItemsLead: any[] = [];

  @Output() loadReportEvent = new EventEmitter<any>();

  viewOrderStatus: boolean = false;
  viewMonth: boolean = false;

  maxData: number = 0;

  public chart_Options: ChartOptions = {
    title: {
      text: 'Completed Orders Trend',
      display: true,
      position: 'top',
      fontSize: 18,
      fontStyle: 'bold',
      fontColor: "black"
    },
    legend: {
      labels: {
        fontColor: "black",
        fontSize: 18,
        fontStyle: 'bold',
      },
      onClick: (event, legendItem) => {
        event.stopPropagation();
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      type: 'logarithmic',
      yAxes: [{
        ticks: {
          beginAtZero: true,
          precision: 0,
          fontColor: "black",
          fontSize: 16,
          fontStyle: 'bold'
        }
      }],
      xAxes: [{
        ticks: {
          fontColor: "black",
          fontSize: 16,
          maxRotation: 45,
          minRotation: 45,
          fontStyle: 'bold',
        }
      }]
    },
    plugins: {
      labels: false,

    }
  };
  @Input() chart_Labels: Label[] = [];
  public chart_Type: ChartType = 'line';
  public chart_Legend = true;
  public chart_Plugins = [];

  @Input() chart_Data: ChartDataSets[] = [];

  public colors = [
    { backgroundColor: "green" },

  ];

  @ViewChild('reportCompletedDetail') pdfReport: ElementRef;

  responseTendineInventory: any = {};
  destroy$ = new Subject<boolean>();


  constructor(private reportingService: ReportingService, private networkService: NetworkService,
    private toastr: ToastrManager,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    if (!this.reportingService.completedDetailLoadedAlmostOneTime) {
      this.initTendineValue();
    } else {
      this.selectedItemsYear = this.reportingService.selectedItemsCompletedDetail.selectedItemsYear;
      this.selectedItemsMonth = this.reportingService.selectedItemsCompletedDetail.selectedItemsMonth;
      this.selectedItemsCountry = this.reportingService.selectedItemsCompletedDetail.selectedItemsCountry;
      this.selectedItemsCustomer = this.reportingService.selectedItemsCompletedDetail.selectedItemsCustomer;
      this.selectedItemsOrderType = this.reportingService.selectedItemsCompletedDetail.selectedItemsOrderType;
      this.selectedItemsBO = this.reportingService.selectedItemsCompletedDetail.selectedItemsBO;
      this.selectedItemsIdGlobal = this.reportingService.selectedItemsCompletedDetail.selectedItemsIdGlobal;
      this.selectedItemsLead = this.reportingService.selectedItemsCompletedDetail.selectedItemsLead;
      this.selectedItemsOrderStatus = this.reportingService.selectedItemsCompletedDetail.selectedItemsOrderStatus;
      this.selectedItemsOrderCluster = this.reportingService.selectedItemsCompletedDetail.selectedItemsOrderCluster;
      this.chart_Labels = this.reportingService.chartLabelsCompleted;
      this.chart_Data = this.reportingService.chartDataCompleted;
    }
  }

  initTendineValue() {
    this.initOrderCluster();
    this.initBO();
    this.initCountry();
    this.initCustomer();
    this.initMonth();
    this.initYear();
    this.initOrderType();
    this.initOrderStatus();
    this.initLead();
    this.initReport();
  }

  initOrderCluster() {
    let arrayOrderCluster: any[] = [];
    if (this.dropdownListOrderCluster && this.dropdownListOrderCluster.length > 0) {
      for (let elem of this.dropdownListOrderCluster) {
        arrayOrderCluster.push(elem);
      }
    }
    this.selectedItemsOrderCluster = arrayOrderCluster;
  }

  initBO() {
    let arrayBO: any[] = [];
    if (this.dropdownListBO && this.dropdownListBO.length > 0) {
      for (let elem of this.dropdownListBO) {
        arrayBO.push(elem);
      }
    }
    this.selectedItemsBO = arrayBO;
  }

  initCountry() {
    let arrayCountry: any[] = [];
    if (this.dropdownListCountry && this.dropdownListCountry.length > 0) {
      for (let elem of this.dropdownListCountry) {
        arrayCountry.push(elem);
      }
    }
    this.selectedItemsCountry = arrayCountry;
  }

  initCustomer() {
    let arrayCustomer: any[] = [];
    if (this.dropdownListCustomer && this.dropdownListCustomer.length > 0) {
      for (let elem of this.dropdownListCustomer) {
        arrayCustomer.push(elem);
      }
    }
    this.selectedItemsCustomer = arrayCustomer;
    this.initCustomerIdGlobal();
  }

  initMonth() {
    let arrayMonth: any[] = [];
    if (this.dropdownListMonth && this.dropdownListMonth.length > 0) {
      for (let elem of this.dropdownListMonth) {
        arrayMonth.push(elem);
      }
    }
    this.selectedItemsMonth = arrayMonth;
  }

  initYear() {
    let arrayYear: any[] = [];
    if (this.dropdownListYear && this.dropdownListYear.length > 0) {
      for (let elem of this.dropdownListYear) {
        if (elem.item_id == this.getCurrentYear()) {
          arrayYear.push(elem);
        }
      }
    }
    this.selectedItemsYear = arrayYear;
  }

  initOrderType() {
    let arrayOrderType: any[] = [];
    if (this.dropdownListOrderType && this.dropdownListOrderType.length > 0) {
      for (let elem of this.dropdownListOrderType) {
        arrayOrderType.push(elem);
      }
    }
    this.selectedItemsOrderType = arrayOrderType;
  }

  loadReport(data: any) {
    this.loadReportEvent.emit(data);
  }

  initReport() {
    let data: any = {
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus,
      selectedItemsOrderCluster: this.selectedItemsOrderCluster
    }
    this.reportingService.setSelectedItemsCompletedDetail(data);
    this.loadReportEvent.emit(data);
  }

  initCustomerIdGlobal() {
    let arrayIdGlobal: any[] = [];
    if (this.selectedItemsCustomer && this.selectedItemsCustomer.length > 0) {
      for (let elem of this.selectedItemsCustomer) {
        let key: string = elem.item_id;
        if (this.idLeadGlobalOfCustomerName) {
          let arrayIds = this.idLeadGlobalOfCustomerName.get(key);
          if (Array.isArray(arrayIds)) {
            for (let globalId of arrayIds) {
              let data: any = {
                item_id: globalId,
                item_text: globalId
              }
              let cust = arrayIdGlobal.find(x => x.item_id == data.item_id);
              if (!cust) {
                arrayIdGlobal.push(data);
              }

            }
          }
        }
      }
    }
    this.selectedItemsIdGlobal = arrayIdGlobal;
  }

  initOrderStatus() {
    let arrayOrderStatus: any[] = [];
    if (this.dropdownListOrderStatus && this.dropdownListOrderStatus.length > 0) {
      for (let elem of this.dropdownListOrderStatus) {
        if (elem.item_id == "COMPLETED") {
          arrayOrderStatus.push(elem);
        }
      }
    }
    this.selectedItemsOrderStatus = arrayOrderStatus;
  }

  initLead() {
    let arrayLead: any[] = [];
    if (this.dropdownListLead && this.dropdownListLead.length > 0) {
      for (let elem of this.dropdownListLead) {
        arrayLead.push(elem);
      }
    }
    this.selectedItemsLead = arrayLead;
  }

  updateFilterEvent(event: any) {
    this.selectedItemsYear = event.selectedItemsYear;
    this.selectedItemsMonth = event.selectedItemsMonth;
    this.selectedItemsCountry = event.selectedItemsCountry;
    this.selectedItemsCustomer = event.selectedItemsCustomer;
    this.selectedItemsOrderType = event.selectedItemsOrderType;
    this.selectedItemsBO = event.selectedItemsBO;
    this.selectedItemsIdGlobal = event.selectedItemsIdGlobal;
    this.selectedItemsLead = event.selectedItemsLead;
    this.selectedItemsOrderStatus = event.selectedItemsOrderStatus;
    this.selectedItemsOrderCluster = event.selectedItemsOrderCluster;
    this.reportingService.setChangedFilterCompletedDetail();
    this.reportingService.setSelectedItemsCompletedDetail(event);
  }

  getCurrentYear(): string {
    const currentYear = new Date().getFullYear();
    return String(currentYear);
  }

  viewReport() {
    if (this.chart_Data && this.chart_Data.length > 0) {
      return true;
    } else {
      return false;
    }
  }


  htmltoPDF() {
    // printDiv is the html element which has to be converted to PDF
    const pdfTable = this.pdfReport.nativeElement;
    html2canvas(pdfTable).then(canvas => {

      const width = 208;
      var height = canvas.height * width / canvas.width;
      var imgData = canvas.toDataURL('image/png');
      var pdf = new jspdf('l', 'mm', 'a4');
      pdf.setFont('gill-sans-nova');
      let widthImage = pdf.internal.pageSize.getWidth();
      let heightImage = pdf.internal.pageSize.getHeight();
      let cont: number = 15;
      let options: TextOptionsLight = {
        align: 'center'
      };
      pdf.setFontSize(20);
      pdf.text("Completed Orders Trend Report", widthImage/2, cont, options);
      pdf.setFontSize(16);
      let orderClusterString: string = this.createTextBySelectedItems(this.selectedItemsOrderCluster);

      let leadmember: string = this.createTextBySelectedItems(this.selectedItemsLead);

      let customers: string = this.createTextBySelectedItems(this.selectedItemsCustomer);

      let bmember: string = this.createTextBySelectedItems(this.selectedItemsBO);

      let nazioni: string = this.createTextBySelectedItems(this.selectedItemsCountry);

      let years: string = this.createTextBySelectedItems(this.selectedItemsYear);

      let mesi: string = this.createTextBySelectedItems(this.selectedItemsMonth);

      let tipi: string = this.createTextBySelectedItems(this.selectedItemsOrderType);

      let orderStatus: string = this.createTextBySelectedItems(this.selectedItemsOrderStatus);

      pdf.addImage(imgData, 'PNG', 2, heightImage/4, widthImage-6, height+20);
      pdf.addPage();

      pdf.text("Completed Orders Trend Filters", widthImage/2, cont, options);

      let styles: Partial<Styles> = {
        font: 'gill-sans-nova'
      };

      autoTable(pdf, {
        head: [['FILTER', 'VALUES']],
        body: [
          ['YEAR', years],
          ['MONTH', mesi],
          ['ORDER CLUSTER', orderClusterString],
          ['LEAD OPERATOR', leadmember],
          ['CUSTOMER', customers],
          ['B OPERATOR', bmember],
          ['COUNTRY', nazioni],
          ['ORDER TYPE', tipi],
          ['ORDER STATUS', orderStatus],
        ],
        startY:  30,
        styles: styles
      });





      pdf.save("OrdersCompletedTrendReport.pdf");

    });

  }



  viexExportPdf() {
    if (this.chart_Data && this.chart_Data.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  createTextBySelectedItems(selectedItem: any[]) {
    let result: string = "";
    if (selectedItem && selectedItem.length > 0) {
      let i: number = 1;
      for (let elem of selectedItem) {

        if (i == selectedItem.length) {
          result = result + (elem.item_text || elem.item_id);
        } else {
          result = result + (elem.item_text || elem.item_id) + " , "
        }
        i++;

      }

    }
    return result;
  }






  ngAfterViewInit(): void {

    this.pdfReport.nativeElement.focus();
  }

  initializeTendine() {

    this.spinner.show("sp1");
    let urlTendineReporting: string = environment.basePath + _ENDPOINT.getTendineReporting;
    let data = {
      body: ''
    }
    this.networkService.post(urlTendineReporting, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.responseTendineInventory = JSON.parse(response.body);
            this.initTendineCountryAndCustomer(this.responseTendineInventory);
            this.initTendine(this.responseTendineInventory);
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.customerOfCountry) {
            this.responseTendineInventory = response;
            this.initTendineCountryAndCustomer(this.responseTendineInventory);
            this.initTendine(this.responseTendineInventory);
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during selectItem reporting Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during selectItem reporting Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  initTendineCountryAndCustomer(responseTendineInventory: any) {
    if (responseTendineInventory && responseTendineInventory.customerOfCountry
      && responseTendineInventory.orderTypeOfOrderCLuster) {
      this.customerOfCountry = new Map(Object.entries(responseTendineInventory.customerOfCountry));
      this.orderTypeOfOrderCLuster = new Map(Object.entries(responseTendineInventory.orderTypeOfOrderCLuster));
      this.idLeadGlobalOfCustomerName = new Map(Object.entries(responseTendineInventory.idLeadGlobalOfCustomerName));
      this.initDropdownCountryCustomer();
    }
  }

  initDropdownCountryCustomer() {
    let country: any[] = [];
    let customer: any[] = [];
    for (let [key, value] of this.customerOfCountry) {
      let data = { item_id: key, item_text: key };
      if (country.indexOf(data) == -1) {
        country.push(data);
      }
      for (let elem of value) {
        let dataCustomer = { item_id: elem, item_text: elem };
        let cust = customer.find(x => x.item_id == dataCustomer.item_id);
        if (!cust) {
          customer.push(dataCustomer);
        }

      }
    }
    this.dropdownListCountry = country;
    this.dropdownListCustomer = customer;
  }

  initTendine(responseTendineInventory: any) {
    this.dropdownListBO = responseTendineInventory.dropdownListBO;
    this.dropdownListOrderCluster = responseTendineInventory.dropdownListOrderCluster;
    this.dropdownListMonth = responseTendineInventory.dropdownListMonth;
    this.dropdownListYear = responseTendineInventory.dropdownListYear;
    this.dropdownListOrderType = responseTendineInventory.dropdownListOrderType;
    this.dropdownListOrderStatus = responseTendineInventory.dropdownListOrderStatus;
    this.dropdownListLead = responseTendineInventory.dropdownListLead;
    this.initTendineValue();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
